import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './PDFHealthComponent.css';

const PDFHealthComponent = () => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/CheckPdfGenerationHealth`)
            .then(res => {
                if (res.status === 200 && res.data.success && res.data.data === "Health check passed successfully.") {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            })
            .catch(() => setStatus('error'));
    }, []);

    return (
        <div className="pdf-health-wrapper">
            {status === 'success' && (
                <div className="health-status success">PDF-ის გენერირების სერვისი ჩართულია ✅</div>
            )}
            {status === 'error' && (
                <div className="health-status error">PDF-ის გენერირების სერვისი გათიშულია, მიმართეთ ადმინისტრაციას! ❌</div>
            )}
            {status === null && (
                <div className="health-status loading">Checking PDF Service...</div>
            )}
        </div>
    );
};

export default PDFHealthComponent;
